import { CollapsibleCard, InfoModal, VStack } from "@starrez/starryui";
import * as React from "react";
import { strings } from "../../../../localisation";
import { EmailPreviewTemplatingErrorType, IEmailPreviewError } from "../../Preview/graphQL/emailPreview";
import { EmailScribanValidationErrorListItem, EmailScribanValidationErrorUnorderedList } from "./EmailScribanValidationErrors.styles";

export interface IEmailScribanValidationErrorsProps {
    Errors: IEmailPreviewError[];
    OnClose: () => void;
}

export const EmailScribanValidationErrors = ({ Errors, OnClose }: IEmailScribanValidationErrorsProps) => {
    const syntaxError = Errors.filter((err) => err.type === EmailPreviewTemplatingErrorType.SyntaxError);
    const unknownVariables = Errors.filter((err) => err.type === EmailPreviewTemplatingErrorType.UnknownVariable || err.type === EmailPreviewTemplatingErrorType.UnknownMemberVariable);
    const inaccessibleMemberVariable = Errors.filter((err) => err.type === EmailPreviewTemplatingErrorType.InaccessibleMemberVariable);

    if (Errors?.length) {
        return (
            <InfoModal Header={strings.ScribanValidation_Error_Header} InfoType="Error" OnCloseRequest={OnClose}>
                <VStack Gap="none">
                    {syntaxError.length > 0 &&
                        <CollapsibleCard Caption={strings.ScribanValidation_Error_Syntax}>
                            <EmailScribanValidationErrorUnorderedList>
                                {syntaxError.map((error, index) => {
                                    return <EmailScribanValidationErrorListItem key={`${error.type}${index}`}>{error.message}</EmailScribanValidationErrorListItem>;
                                })}
                            </EmailScribanValidationErrorUnorderedList>
                        </CollapsibleCard>
                    }
                    {unknownVariables.length > 0 &&
                        <CollapsibleCard Caption={strings.ScribanValidation_Error_UnknownVariables}>
                            <EmailScribanValidationErrorUnorderedList>
                                {unknownVariables.map((error, index) => {
                                    return <EmailScribanValidationErrorListItem key={`${error.type}${index}`}>{error.message}</EmailScribanValidationErrorListItem>;
                                })}
                            </EmailScribanValidationErrorUnorderedList>
                        </CollapsibleCard>
                    }
                    {inaccessibleMemberVariable.length > 0 &&
                        <CollapsibleCard Caption={strings.ScribanValidation_Error_InaccessibleMemberVariable}>
                            <EmailScribanValidationErrorUnorderedList>
                                {inaccessibleMemberVariable.map((error, index) => {
                                    return <EmailScribanValidationErrorListItem key={`${error.type}${index}`}>{error.message}</EmailScribanValidationErrorListItem>;
                                })}
                            </EmailScribanValidationErrorUnorderedList>
                        </CollapsibleCard>
                    }
                </VStack>
            </InfoModal>
        );
    }

    return null;
};
